/* ONE BOUT — PDP below the fold (Sprint 3 / P2).
   [data-ob-kl-write] (sections/apps.liquid, layout "OB reviews") → opens the Klaviyo Reviews "Write a review" form.
   Klaviyo renders its widget in the light DOM (#fulfilled-reviews-all) and exposes no public "open form" API,
   so the button forwards the click to Klaviyo's own button (hidden by assets/ob-klaviyo-reviews.css).
   Before the widget has rendered (Klaviyo loads asynchronously) the button scrolls to the widget instead. */
const KL_BUTTONS = [
  '.kl_reviews__button_bar .kl_reviews__button',                  // tabs row "Write a review"
  '.kl_reviews__list_empty_state__container .kl_reviews__button', // empty-state variant
  'button.kl_reviews__button:not(.kl_reviews__button--outline)',
];

function klaviyoWriteButton(scope) {
  for (const selector of KL_BUTTONS) {
    const button = scope.querySelector(`#fulfilled-reviews-all ${selector}`);
    if (button) return button;
  }
  return null;
}

function onClick(event) {
  const trigger = event.target.closest('[data-ob-kl-write]');
  if (!trigger) return;
  const scope = trigger.closest('.ob-klr') || document;
  const button = klaviyoWriteButton(scope) || klaviyoWriteButton(document);
  if (button) {
    button.click();
    return;
  }
  const widget = document.getElementById(trigger.getAttribute('aria-controls') || '');
  if (widget) widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

if (!window.obKlaviyoWriteBound) {
  window.obKlaviyoWriteBound = true;
  document.addEventListener('click', onClick);
}
